import { lazy, Suspense } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { ViewportCenterCircle } from "@newComponents/common/ViewportCenterCircle";

const EConsentPage = lazy(() => import("@newPages/eConsent/EConsentPage"));
const EConsentSubjectListPage = lazy(() => import("@newPages/eConsent/EConsentSubjectListPage"));
const EConsentStatusPage = lazy(() => import("@newPages/eConsent/eConsentStatusPage/EConsentStatusPage"));
const EConsentICFDetailPage = lazy(() => import("@newPages/eConsent/EConsentICFDetailPage"));

export function EConsentRoute() {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<ViewportCenterCircle />}>
      <Switch>
        <Route exact path={`${match.url}`} component={EConsentPage} />
        <Route exact path={`${match.url}/folders/:folderId`} component={EConsentSubjectListPage} />
        <Route exact path={`${match.url}/folders/:folderId/signers/:signerId/signs/:documentSignId`} component={EConsentStatusPage} />
        <Route exact path={`${match.url}/files/:fileId(\\d+)`} component={EConsentICFDetailPage} />
        <Redirect from="*" to="/404?tr" />
      </Switch>
    </Suspense>
  );
}
